import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "./authService";
import { Auth } from "aws-amplify";

const initialState = {
  token: "",
  user: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//login a user
export const login = createAsyncThunk("auth/login", async (thunkAPI) => {
  try {
    return await authService.login(); //calls authService login
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

//logout user
export const logout = createAsyncThunk("auth/logout", async () => {
  //console.log("Logging out");
  await Auth.currentSession();
  Auth.signOut();
  sessionStorage.removeItem("user");
  await authService.logout();
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.user = action.payload;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
        state.message = action.payload && action.payload.errorMessage;
        state.user = null;
        state.token = null;
      })
      .addCase(logout.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.user = null;
        state.token = null;
      });
  },
});

export const { reset } = authSlice.actions;
export default authSlice.reducer;
